export const COMPANY_IDS = {
  MATCH: 'match',
};

export const companyName = COMPANY_IDS;
